import React from 'react';
import PropTypes from 'prop-types';

const UrlEncodedField = ({ record = {}, source, display }) => {
  if (display === undefined || !display) {
    display = source;
  }

  return (
    <a href={new Buffer(record[source], 'base64').toString('utf-8')} target="_blank" rel="noopener noreferrer">
      {record[display]}
    </a>
  );
};

UrlEncodedField.propTypes = {
  record: PropTypes.object,
  source: PropTypes.string.isRequired,
};

export default UrlEncodedField;



// WEBPACK FOOTER //
// ./src/resources/ui/UrlEncodedField.js